<template>
  <span class="rf-icon" aria-hidden="true">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
      <path
        fill="inherit"
        stroke="none"
        d="M5.6 20q-.6 0-1.1-.5T4 18.4V5.6q0-.6.5-1.1T5.6 4h5.6v1H5.6q-.2 0-.4.2l-.2.4v12.8q0 .2.2.4l.4.2h12.8q.2 0 .4-.2l.2-.4v-5.6h1v5.6q0 .6-.5 1.1t-1.1.5zm4.1-5-.7-.7L18.3 5H14V4h6v6h-1V5.7z"
      />
    </svg>
  </span>
</template>
